import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** システム管理者権限 */
enum AdminCheckMethod {
  hasAdmin = 'systemAdmin',
  notAdmin = 'notSystemAdmin',
}

function paymentMethodToDisplay(value: AdminCheckMethod) {
  switch (value) {
    case AdminCheckMethod.hasAdmin:
      return 'あり';
    case AdminCheckMethod.notAdmin:
      return 'なし';
  }
}

const nameConfig = {
  hasAdmin: new Map([
    [Locale.ja, 'あり'],
    [Locale.en, 'Has Admin'],
  ]),

  notAdmin: new Map([
    [Locale.ja, 'なし'],
    [Locale.en, 'Not Admin'],
  ]),
};

const toEnum = rawValueToEnum(AdminCheckMethod, AdminCheckMethod.hasAdmin);
const toDisplay = enumToName(AdminCheckMethod, nameConfig);
const toDisplayWithPrefix = enumToName(AdminCheckMethod, nameConfig, { prefix: true });

export const adminCheckMethod = {
  enum: AdminCheckMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
  paymentMethodToDisplay,
};
export type { AdminCheckMethod };
